import styled from "styled-components";
import { resolvePaletteRoleForegroundToken } from "../../../functions/resolvePaletteRoleForegroundToken";

import {
	INPUT_BORDER_SIZE,
	INPUT_HEIGHT,
} from "../TextInputContainer/TextInputContainer.styles";

import { StyledTextFieldProps } from "./TextField.types";

export const StyledTextField = styled.input<StyledTextFieldProps>`
	margin-top: ${({ hasLabel, theme }) => (hasLabel ? theme.space["sm"] : 0)};
	border: ${INPUT_BORDER_SIZE} solid transparent;
	background: transparent;
	width: 100%;
	height: ${INPUT_HEIGHT};
	width: 100%;
	padding: ${({ theme }) => `0 ${theme.space.md}`};
	left: 0;
	z-index: 1;
	box-sizing: border-box;
	color: ${({ colorOn, theme }) =>
		theme.palette.hexFor(resolvePaletteRoleForegroundToken(colorOn, 1))};

	:focus {
		outline: none;
	}

	:focus + .Label,
	:not(input[value=""]) + .Label {
		transform: translateY(-50%);
	}
`;
